/**
 * Like Service
 */

DM.Service.ProductSimilar = (function (DM) {

    var URL_ENDPOINT = DM.Config.isSimilarPhotosEnabled ? '/similar/products-v2' : '/similar/products';

    return {
        _cache: [],
        _fetchProductsFromServer: function (productId, min, source, useSplendi, splendiOperationType, complementaryCategoryId) {
            const url = URL_ENDPOINT + '?' +
                'productId=' + productId +
                '&min=' + (min || 4) +
                '&appVersion=' + source +
                '&useSplendi=' + useSplendi +
                '&splendiOperationType=' + splendiOperationType +
                '&complementaryCategoryId=' + complementaryCategoryId;
            return fetch(url)
                .then(response => response.json());
        },
        _fetchProductsFromCache: function (cache, productId, splendiOperationType, complementaryCategoryId) {
            return cache.filter(function (item) {
                return item.productId === productId
                    && item.splendiOperationType === splendiOperationType
                    && item.complementaryCategoryId === complementaryCategoryId;
            })[0];
        },
        _addToCache: function (cache, data) {
            return cache.push(data);
        },
        getProducts: function (productId, min, source, useSplendi = false, splendiOperationType = 1,
                               complementaryCategoryId = null) {
            var cached = this._fetchProductsFromCache(this._cache, productId, splendiOperationType, complementaryCategoryId);
            return new Promise((resolve, reject) => {
                if (cached) {
                    resolve(cached.similar);
                } else {
                    this._fetchProductsFromServer(productId, min, source, useSplendi, splendiOperationType, complementaryCategoryId)
                        .then(function (response) {
                            this._addToCache(this._cache, {
                                productId: productId,
                                similar: response,
                                splendiOperationType: splendiOperationType
                            });
                            resolve(response);
                        }.bind(this))
                        .catch(function (error) {
                            reject(error);
                        });
                }
            });
        }
    };
})(window.DM);
